import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/MultipleInputGear/1_1x.png`;
const Pic2 = `${FullPath}/MultipleInputGear/2_1x.png`;
const Pic3 = `${FullPath}/MultipleInputGear/3_1x.png`;
const Pic4 = `${FullPath}/MultipleInputGear/4_1x.png`;
const Pic5 = `${FullPath}/MultipleInputGear/5_1x.png`;
const Pic6 = `${FullPath}/MultipleInputGear/6_1x.png`;
const Pic7 = `${FullPath}/MultipleInputGear/7_1x.png`;
const Pic8 = `${FullPath}/MultipleInputGear/8_1x.png`;


export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,


    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}